import { render, staticRenderFns } from "./BreakSettings.vue?vue&type=template&id=2708a0ed&"
import script from "./BreakSettings.vue?vue&type=script&lang=js&"
export * from "./BreakSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports